export default __webpack_public_path__ + "static/media/refer-logo.b2135301.svg";